import { spacing } from "@indeed/ifl-tokens/react-native";
import React from "react";
import { StyleSheet } from "react-native";

import { Box, Skeleton } from "../../../../../../../mads";
import { SkeletonSize, SkeletonVariant } from "../../../../../../../mads/Skeleton";
import { useI18n } from "../../../../../../../shared/I18n";
import { useIsDesktopDisplay } from "../../../../../context/ViewJobDisplayContext";
import { ViewJobDivider } from "../../../Divider";

const PLACEHOLDER_ROW_KEYS = ["row-1", "row-2", "row-3", "row-4", "row-5"];

/**
 * Loading placeholder shown while Match Overview refetches after the seeker adds
 * a resume. Mirrors the layout of MatchOverviewQualificationCollection — heading,
 * description, qualifications sub-heading, then the requirement rows — so the
 * panel keeps its footprint as it hydrates in place.
 */
export const MatchOverviewSkeleton: React.FC = () => {
  const gt = useI18n();
  const isDesktop = useIsDesktopDisplay();

  return (
    <>
      <Box
        sx={styles.container}
        testID="vj-match-overview-skeleton"
        accessibilityLiveRegion="polite"
      >
        <Skeleton
          variant={SkeletonVariant.HEADING}
          size={isDesktop ? SkeletonSize.MD : SkeletonSize.SM}
          sx={styles.headingBar}
          ariaLabel={gt.gettext("Loading your match overview")}
        />
        <Skeleton variant={SkeletonVariant.TEXT} size={SkeletonSize.SM} accessible={false} />
        <Skeleton
          variant={SkeletonVariant.HEADING}
          size={SkeletonSize.SM}
          sx={styles.subHeadingBar}
          accessible={false}
        />
        <Box sx={styles.qualificationRows}>
          {PLACEHOLDER_ROW_KEYS.map((key) => (
            <Skeleton
              key={key}
              variant={SkeletonVariant.TEXT}
              size={SkeletonSize.MD}
              sx={styles.qualificationRow}
              accessible={false}
            />
          ))}
        </Box>
      </Box>
      <ViewJobDivider />
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBlock: spacing.sc4,
    gap: spacing.sc3,
  },
  headingBar: {
    width: 180,
  },
  subHeadingBar: {
    width: 220,
  },
  qualificationRows: {
    gap: spacing.sc3,
  },
  qualificationRow: {
    height: spacing.s6,
  },
});
